import { render } from "./GrantsSettings.vue?vue&type=template&id=dce84040"
import script from "./GrantsSettings.vue?vue&type=script&lang=js"
export * from "./GrantsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/GrantsSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dce84040"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dce84040', __exports__)) {
    api.reload('dce84040', __exports__)
  }
  
  module.hot.accept("./GrantsSettings.vue?vue&type=template&id=dce84040", () => {
    api.rerender('dce84040', render)
  })

}


export default __exports__